




























import Vue from 'vue';
import { mapState } from 'vuex';
import * as dateFns from 'date-fns'
import {pushAddon} from '../shared/utils';
import { MUTATIONS, ACTIONS, Branch } from "@/shared/store";

export default Vue.extend({
  data() {
    return {
      repos: [] as any[],
      loading: false as boolean,
    }
  },
  created() {
    this.loading = true;
    this.$store.dispatch(ACTIONS.FETCH_MY_REPOS).then(repos => {
      this.loading = false;
      this.repos = repos;
    })
  },
  filters: {
    formatDate(value: string): string {
      return dateFns.distanceInWordsToNow(dateFns.parse(value));
    }
  },
  computed: {
    columns(): any[] {
      return [
        { label: 'Name', field: 'fullName', sortable: true},
        { label: 'Last pushed', field: 'pushedAt'},
        { label: 'Last updated', field: 'updatedAt'},
      ]
    }
  },
  methods: {

  },
});
